import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import MainModule from '../../modules/main'

export interface LvcAccountNavItem {
  label: string
  url: string
  isActive: boolean
  gtmLinkText?: string
}

export class LvcAccountNavItem extends MinzeElement {
  attrs: Attrs = [['label', ''], ['url', ''], 'gtm-link-text']
  static observedAttributes = ['label', 'url']

  reactive: Reactive = [['isActive', false]]

  onReady = () => {
    const currentPath = window.location.pathname
    const navUrl = new URL(this.url, window.location.origin)
    this.isActive = currentPath === navUrl.pathname
  }
  handleOnClick = async (e: MouseEvent) => {
    e.preventDefault()
    try {
      if (this.gtmLinkText) {
        await MainModule.getInstance().analyticsTrack('mon_compte_sections', {
          link_text: this.gtmLinkText,
        })
      }
    } catch (error) {
      console.error('Error tracking analytics:', error)
    }
    window.location.href = this.url
  }

  html = () => `
    <a href="${this.url}" class="nav-item-link">
      <slot name="icon"></slot>
      <div class="nav-item-label">${this.label}</div>
    </a>
  `

  css = () => `
    :host {}

    .nav-item-link {
      display: flex;
      align-items: center;
      gap: 10px;
      color: #1E007D;
      font-size: 0.875em;
      font-weight: ${this.isActive ? '700' : '500'};
      line-height: 120%;
      text-decoration: none;
    }

    .nav-item-link:hover .nav-item-label {
      text-decoration: underline;
      text-underline-offset: 4px;
    }

    ::slotted([slot=icon]) {
      height: 30px;
      color: ${this.isActive ? '#FF4600' : '#1E007D'};
    }
  `
  eventListeners: EventListeners = [['a', 'click', e => this.handleOnClick(e as MouseEvent)]]
}
